import React, { useEffect } from "react";
import "./JobLocationDetails.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import CourierInfoComponent from "./CourierInfoComponent/CourierInfoComponent";
import OrderStatusComponent from "./OrderStatusComponent/OrderStatusComponent";
import ReviewCardComponent from "./ReviewCardComponent/ReviewCardComponent";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../features/order/orderSlice";

const JobLocationDetails = () => {
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "ORDER", link: "/my-order" },
    { name: "JOB DETAILS" },
  ];
  const dispatch = useDispatch();
  const { id } = useParams();
  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    if (id) {
      dispatch(getOrder(id));
    }
  }, [dispatch, id]);
  return (
    <section className="JobLocationDetails">
      <div className="custom_container">
        <div className="breadcrump_holder">
          <div className="Breadcrumb_div">
            <Breadcrumb_comp data={breadcrumbData} />
          </div>
        </div>

        <div className="job_location_main_div">
          <div className="row">
            <div className="col-lg-8">
              <div className="order_status_div">
                <OrderStatusComponent order={order} />
              </div>
            </div>

            <div className="col-lg-4">
              <div className="row">
                <div className="col-lg-12 col-md-6">
                  <div className="courier_div">
                    <CourierInfoComponent order={order} />
                  </div>
                </div>

                { order?.Rating_Review === null && order?.order_status_id === 15 && (
                  <div className="col-lg-12 col-md-6">
                    <div className="review_div">
                      <ReviewCardComponent order={order} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobLocationDetails;
